export default __webpack_public_path__ + "static/media/logo-white-trames.dda58aee.svg";